import LOOKER_ACTIONS from '../shared/lrsActionsConstant';
import { getLrsExtensions, getLrsObjectId as getSharedLrsObjectId } from '../shared/lrsHelpers';
import { ALL_MEASURES } from '../../../constants/reading/MeasuresConstants';

const { TRO, LEXILE_EVENT } = LOOKER_ACTIONS;

const {
    AUDIO_PLAYER_EVENT,
    BOOK_RESCORING_EVENT,
    REVERT_EVENT,
    RESCORED_WITH_THIRD_BOOK_EVENT,
    RESCORED_NOT_SCORED_BOOK_EVENT,
} = TRO;

const getLRSObjectForRscoredTROBook = (eventType, complexityLevel) =>
    `${eventType} rescoring of ${complexityLevel} tro book`;

export const getReadingLrsObjectId = (action, store) => {
    const { type, eventType, complexityLevel } = action;

    switch (type) {
        case AUDIO_PLAYER_EVENT:
            return 'TRO Audio player';
        case BOOK_RESCORING_EVENT:
            return getLRSObjectForRscoredTROBook(eventType, complexityLevel);
        case RESCORED_NOT_SCORED_BOOK_EVENT:
            return `${eventType} rescoring of not scored tro book`;
        case REVERT_EVENT:
            return 'Revert tro book to SB version';
        case RESCORED_WITH_THIRD_BOOK_EVENT:
            return 'Rescored tro with third book';
        case LEXILE_EVENT:
            return 'https://api.amplify.com/xapi/objects/benchmark-dashboard-lexile-button';
        default:
            return getSharedLrsObjectId(action, store, ALL_MEASURES);
    }
};

export const getReadingLrsExtensions = action => {
    return getLrsExtensions(action, ALL_MEASURES);
};

export default {
    getReadingLrsObjectId,
};
